import { put } from 'redux-saga/effects'
import { updateFollowupAction, fetchFollowupsByOperatorAction } from '../../handles'
import { updateFollowup } from '../_http/followup'

export function* updateFollowupSaga(action: ReturnType<typeof updateFollowupAction.request>) {
  const { followupId, dataToUpdate, companyId, ownerId, operatorId } = action.payload
  try {
    yield updateFollowup(followupId, dataToUpdate)
    yield put(updateFollowupAction.success())

    if (companyId && ownerId) {
      yield put(fetchFollowupsByOperatorAction.request({ companyId, ownerId, operatorId, page: 1 }))
    }
  } catch (error) {
    yield put(updateFollowupAction.failure())
  }
}
